import React from "react";
import TextInput from "../TextInput";
import Button from "../Button";
import Disclaimer from "../Disclaimer";
import XError from "../../assets/img/x-error.svg";
import {
  fireMailErrorSwal,
  fireMailSentSwal,
  firePasswordRecoverySwal,
} from "../../utils/swals";
import { serverUrl } from "../../serverURL";

const CheckPassword = ({
  password,
  email,
  setPassword,
  handleLogin,
  isDisclaimerVisible,
}) => {
  const handleRecoverPassword = async () => {
    const res = await fetch(serverUrl + "/init-recupero-clave", {
      method: "POST",
      body: JSON.stringify({ email }),
    });
    if (res.status === 201) {
      fireMailSentSwal();
    } else {
      fireMailErrorSwal();
    }
  };

  const handleForgottenPassword = () => {
    firePasswordRecoverySwal(handleRecoverPassword);
  };
  return (
    <>
      <div> 
        <p>Bienvenido,</p>
        <p className="fw600">Por favor ingresá tu clave</p>
      </div>
      <div style={{ width: "100%" }} className="pwd-group">
        <TextInput
          placeholder={"Clave"}
          type={"password"}
          onChange={(e) => setPassword(e.target.value)}
        />
        <span onClick={handleForgottenPassword}>Olvidé mi clave</span>
      </div>
      <Button
        variant={`login-btn ${password.length !== 0 ? "enabled" : ""}`}
        isDisabled={password.length === 0}
        onClick={handleLogin}
      >
        Ingresar
      </Button>
      <Disclaimer
        isVisible={isDisclaimerVisible}
        title={"Tu clave es incorrecta"}
        subtitle={"Volvé a ingresar tu clave para poder iniciar sesión."}
        variant={"red"}
        pathIcono={XError}
      />
    </>
  );
};

export default CheckPassword;
